// extracted by mini-css-extract-plugin
export default {"msgM":"d2d5d4b161"};